export default __webpack_public_path__ + "0cfe3a75ce7da1bebb67ec5d46ac66b4.webp";